import request from '../request';

export function getMessageList(params) {
    return request('/notice/getUserMsg', {
        method: 'GET',
        params
    });
}
export function readMessage() {
    return request(`/notice/changstatus`, {
        method: 'POST',
    });
}
